module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_9006.a53ebfd2.png";